import React, {useEffect, useState} from 'react'
import moment from 'moment-timezone'
import {getLayout} from '../../../components/OrderLayout'
import {lookupStorageKey} from '../../../apollo/cache'
import {useSessionStorageState} from '../../../utils/useSessionStorageState'
import H2 from '../../../components/headings/H2'
import Subtitle from '../../../components/headings/Subtitle'
import {Address} from '../../../components/Address'
import {OrderSummary} from '../../../components/OrderSummary'
import {OrderItem} from '../../../components/OrderItem'
import ShadowBox from '../../../components/layout/ShadowBox'

const initialState = {
  orderNumber: '',
  email: '',
  order: '',
}

const validReasons = ['Design']

const Order = () => {
  const orderfromlocal = JSON.parse(
    localStorage.getItem('dangle-it-crm:lookup-state'),
  )
  // console.log(orderfromlocal, 'orderfromlocal')
  // console.log(
  //   orderfromlocal.order.shipping,
  //   'orderfromlocal.order.shipping',
  // )

  const [state] = useSessionStorageState(
    lookupStorageKey,
    initialState,
  )

  const [orderItems, setOrderItems] = useState(null)
  const [originalEta, setOriginalEta] = useState(null)
  const [rushedEta, setRushedEta] = useState(null)
  // console.log(orderItems, 'states?.order.order_items 33')

  const {order} = orderfromlocal
  // const shipping = orderfromlocal?.order?.shipping
  const {order_items, customer, shipping_method, shipping} = order

  const rushProductionPrice = order?.order_metadata?.find(
    (meta) => meta.key === 'Rush Production Price',
  )?.value
  const normalizedRushProductionPrice =
    typeof rushProductionPrice === 'string'
      ? rushProductionPrice.trim()
      : rushProductionPrice
  const hasRushProductionPrice =
    normalizedRushProductionPrice != null &&
    String(normalizedRushProductionPrice) !== ''
  const orderItemsWithoutRushProduction = (order_items ?? []).filter(
    (item) => !item.name?.includes('Rush Production'),
  )
  const isRushOrder = hasRushProductionPrice
  const rushProductionDisplayItem = hasRushProductionPrice
    ? {
        id: 'rush-production-metadata',
        name: 'Rush Production',
        price: normalizedRushProductionPrice,
        quantity: 1,
        variation_list: [],
        metadata: [{ key: 'image', value: '/product_rush_production.png' }],
      }
    : null
  const orderSummaryItems = rushProductionDisplayItem
    ? [...orderItemsWithoutRushProduction, rushProductionDisplayItem]
    : orderItemsWithoutRushProduction

  const convertToEST = (dateAdded: string): string => {
    const estDate = moment
      .tz(dateAdded, 'YYYY-MM-DD HH:mm:ss', 'UTC')
      .tz('America/New_York')
    return estDate.format('YYYY-MM-DD HH:mm:ss')
  }

  useEffect(() => {
    const fetchEtas = async () => {
      if (!isRushOrder || !order?.date_added) return
      try {
        const formattedOrderDate = convertToEST(order.date_added)
        const [originalResponse, rushedResponse] = await Promise.all([
          fetch('/api/deliveryDates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ order_date: formattedOrderDate }),
          }),
          fetch('/api/deliveryDates', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ order_date: formattedOrderDate, rush: true }),
          }),
        ])

        if (originalResponse.ok) {
          const originalDates = await originalResponse.json()
          setOriginalEta({
            minimumDeliveryDate: originalDates.minimumDeliveryDate,
            maximumDeliveryDate: originalDates.maximumDeliveryDate,
          })
        }

        if (rushedResponse.ok) {
          const rushedDates = await rushedResponse.json()
          setRushedEta({
            minimumDeliveryDate: rushedDates.minimumDeliveryDate,
            maximumDeliveryDate: rushedDates.maximumDeliveryDate,
          })
        }
      } catch (error) {
        console.error('Error fetching ETAs:', error)
      }
    }

    fetchEtas()
  }, [isRushOrder, order?.date_added])

  // console.log(shipping, 'order_itemsoforderdetails')
  // console.log(shipping, 'shippingforderdetails')

  if (!orderfromlocal.order) return null

  return (
    <>
      {/* <ShadowBox> */}
      <div className="item-box order-item-box">
        {/* <H2>Items</H2>
          <Subtitle>Ordered items and their details.</Subtitle> */}
        {orderSummaryItems.map(item => {
          // console.log(item)
          if (
            item.variation_list.find(
              v => v.key === 'Replace-Refund',
            )
          )
            return null
          return (
            <div
              className="order-summary-item repalcement-item"
              key={item.id}
              tw="mt-2 -mx-2 p-2 flex flex-wrap items-start justify-between"
            >
              <OrderItem
                setOrderItems={setOrderItems}
                item={item}
                hasPrice={true}
                // order_items={order_items}
                states={state} 
                shQuantity={undefined}
                referenceSection='order_summary'
                showQuantity={false}
                originalEta={originalEta}
                rushedEta={rushedEta}
                />
            </div>
          )
        })}
      </div>
      {/* </ShadowBox> */}

      {/* <ShadowBox>
      <div className="item-box">
        <H2>Payment Summary</H2>
        <Subtitle>A breakdown of your transaction.</Subtitle>
        <OrderSummary order={order} />
      </div>
      </ShadowBox> */}

      <div
        tw="sm:grid sm:grid-cols-2 sm:gap-6 "
        className="mob-flex"
      >
        {/* <ShadowBox> */}
        <div className=" item-box border-top address address-box">
          <Address
            address={shipping}
            title="Shipping Address"
            subtitle="This is where your order will ship."
          />
        </div>
        {/* </ShadowBox> */}
        {/* <ShadowBox> */}
        <div className="item-box border-top mob-pl address-box ">
          <OrderSummary order={order} />
          {/* <Address
            address={customer}
            title="Billing Address"
            subtitle="This is the address associated with your payment method."
          /> */}
        </div>
        {/* </ShadowBox> */}
      </div>
      {/* <h3 tw="text-lg leading-6 font-medium text-brand">Shipping Method</h3>
      <p tw="mt-2 text-base text-gray-400">{shipping_method}</p> */}
    </>
  )
}

Order.getLayout = getLayout
Order.displayName = 'OrderDetails'
export default Order
